export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/9d6e324a8707cdf9e8f56894c879cc25.jpg"
          alt="Digital Security Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      {/* Floating Geometric Shapes */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 right-1/4 w-32 h-32 border-2 border-teal-400/30 rounded-lg rotate-12 animate-pulse"></div>
        <div className="absolute bottom-1/3 right-1/3 w-24 h-24 border-2 border-teal-500/20 rounded-full animate-pulse delay-100"></div>
        <div className="absolute top-1/3 right-1/5 w-20 h-20 border-2 border-cyan-400/25 rotate-45 animate-pulse delay-200"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto w-full">
        <h2 className="text-7xl font-extrabold text-white mb-6 leading-tight tracking-tight">
          SLOZNA BRACA
        </h2>
        <p className="text-5xl font-light italic text-teal-300 mb-12">
          Secure Your Digital Freedom
        </p>
        <p className="text-lg text-white/80 mb-14 max-w-2xl mx-auto leading-relaxed">
          Enterprise-grade VPN protection for your privacy and security
        </p>
        <button 
          onClick={scrollToContact}
          className="px-12 py-4 bg-teal-500 text-black text-base font-bold rounded-full hover:bg-teal-400 transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-teal-500/50 whitespace-nowrap cursor-pointer"
        >
          Get Started
        </button>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
